import {EmptyControl, MaxLength, MinLength, NestedArray, Required} from '@hvlng/framework-bff/core';
import {HvlDateConverter} from '@hvlng/framework-bff/util';
import {JsonObject, JsonProperty} from 'json2typescript';
import {PerEntityInfoAttributesModel} from "./per-entity-info-attributes-model";
import {PerAdvancedSearchRuleModel} from "./per-advanced-search-rule-model";
import {PerAdvancedSearchEntityModel} from "./per-advanced-search-entity-model";

@JsonObject('KovanHrPerAdvancedSearchQueryModel')
export class PerAdvancedSearchQueryModel {
    @NestedArray(PerAdvancedSearchEntityModel)
    @JsonProperty('entityModel', [PerAdvancedSearchEntityModel], true)
    entityModel: Array<PerAdvancedSearchEntityModel> = new Array<PerAdvancedSearchEntityModel>();


}
